import React, { useEffect } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import LastCsvUploadBanner from './LastCsvUploadBanner';
import makeGetEntityTypeStatus from 'fetches/makeGetEntityTypeStatus';
import { useData } from 'resift';
import usePrevious from 'helpers/usePrevious';
import { useLocation } from 'react-router';
import makeGetEntitiesListFetch from 'fetches/makeGetEntitiesListFetch';

interface Props {
  entityTypeId: string;
}

const waitTime = 1000 * 10;

function Container({ entityTypeId }: Props) {
  const dispatch = useDispatch();
  const getLastSyncStatus = makeGetEntityTypeStatus(entityTypeId);
  const lastSyncStatusInfo = useData(getLastSyncStatus);
  const prevLastSyncStatusInfo = usePrevious(lastSyncStatusInfo);
  const currentSyncStatus = _get(lastSyncStatusInfo, ['syncStatus', 'currentSyncStatus']);
  const shouldStopPolling = !!currentSyncStatus && _isEmpty(currentSyncStatus);

  const location = useLocation();
  const search = location.search;
  const getEntitiesList = makeGetEntitiesListFetch(entityTypeId);

  useEffect(() => {
    if (prevLastSyncStatusInfo !== lastSyncStatusInfo) {
      // (note - pearl) Refetch entities list when sync status changes, the code below referenced
      // PagesTab/container, could potentially extract it
      if (entityTypeId) {
        const query = queryString.parse(search);
        const rawNameQuery = _get(query, 'q');
        const nameQuery = Array.isArray(rawNameQuery) ? rawNameQuery[0] : rawNameQuery;
        const searchQuery = {
          ...query,
          nameQuery,
          entityTypeId: entityTypeId,
        };
        dispatch(getEntitiesList({ query: searchQuery }));
      }
    }

    if (!entityTypeId || shouldStopPolling) {
      return;
    }

    const interval = setInterval(() => {
      dispatch(getLastSyncStatus());
    }, waitTime);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch, entityTypeId, getLastSyncStatus, shouldStopPolling]);

  if (!lastSyncStatusInfo) {
    return null;
  }

  return <LastCsvUploadBanner entityTypeId={entityTypeId} />;
}

export default Container;
